<template>
  <div class="content-section">
    <div class="exhibition-view">
      <div class="tab-head-first row-flex jc ac">
        <div
          class="name"
          :class="{ active: firstIndex == 0 }"
          @click="handleFirstTab(0)">
          图片
        </div>
        <div
          class="name"
          :class="{ active: firstIndex == 1 }"
          v-if="videoList.length > 0"
          @click="handleFirstTab(1)">
          视频
        </div>
      </div>
      <div class="tab-content-first">
        <div v-show="firstIndex == 0">
          <div class="tab-head row-flex ac">
            <!-- 图片类型 -->
            <div
              class="name"
              v-for="(imageTypeItem, index) in imageList"
              :key="imageTypeItem.name"
              v-show="imageTypeItem.children.length > 0"
              :class="{ active: index == imageTypeIndex }"
              :data-1="index"
              :data-active="imageTypeIndex"
              @click="handleTabType(imageTypeItem.name, index)">
              {{ imageTypeItem.name }}
            </div>
            <div
              class="name"
              :class="{ active: imageTypeIndex == 99 }"
              v-if="exhibitionHallList && exhibitionHallList.length > 0"
              @click="handleTabType('展馆图片', 99)">
              展馆图片
            </div>
          </div>
          <!--  -->
          <div class="tab-main">
            <!--  -->
            <div
              class="tab-content"
              v-for="(imageTypeItem, index) in imageList"
              :key="imageTypeItem.name"
              v-show="imageTypeIndex == index">
              <!-- 年份 -->
              <div class="year-box row-flex">
                <div
                  v-for="(yearItem, yearIndex) in imageTypeItem.children"
                  :key="`${yearItem.resourceType}-${yearItem.yearName}`"
                  :class="{ active: tabYearActive == `${imageTypeItem.name}-${yearIndex}` }"
                  :data-1="`${imageTypeItem.name}-${yearIndex}`"
                  :data-active="tabYearActive"
                  class="year-item"
                  @click="handleTabYear(imageTypeItem.name, yearIndex)">
                  {{ yearItem.yearName }}
                </div>
              </div>
              <div class="">
                <!-- 年份 -->
                <div
                  class="type-item"
                  v-for="(yearItem, yearIndex) in imageTypeItem.children"
                  :key="`${yearItem.resourceType}-${yearItem.yearName}-${yearIndex}`">
                  <!-- 图片 -->
                  <div
                    class="type-item-box row-flex-wrap"
                    v-for="(itemImage, itemIndex) in yearItem.children"
                    v-show="`${imageTypeItem.name}-${yearIndex}` == yearActiveIndex"
                    :key="`${itemImage.id}`"
                    :data-Index="`${imageTypeItem.name}-${yearIndex}`"
                    :data-active="yearActiveIndex">
                    <!-- 图片 picList -->
                    <div
                      class="image-box"
                      v-for="(item, picIndex) in itemImage.picList"
                      :key="`${itemImage.id}-${picIndex}`">
                      <el-image
                        class="item-image"
                        style="width: 258px; height: 158px"
                        :src="item"
                        fit="cover"
                        :preview-src-list="itemImage.picList"></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-content"
              v-show="imageTypeIndex == 99">
              <div>
                <div class="type-item">
                  <!-- 展馆图片 -->
                  <div class="type-item-box row-flex-wrap">
                    <div
                      class="image-box"
                      v-for="(itemImage, index) in exhibitionHallList"
                      :key="index">
                      <el-image
                        :preview-src-list="exhibitionHallList"
                        :src="itemImage"
                        class="item-image"
                        fit="cover"
                        style="width: 258px; height: 158px"></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="firstIndex == 1">
          <div class="tab-main">
            <div
              class="tab-content"
              v-if="videoList && videoList.length > 0">
              <!-- 年份 -->
              <div
                class="year-box row-flex"
                style="padding-top: 20px">
                <div
                  v-for="(yearItem, yearIndex) in videoList"
                  :key="`${yearItem.resourceType}-${yearItem.yearName}-${yearIndex}`"
                  :class="{ active: videoYearActive == `${yearItem.yearName}-${yearIndex}` }"
                  :data-1="`${yearItem.yearName}-${yearIndex}`"
                  :data-active="videoYearActive"
                  class="year-item"
                  @click="handleTabYear(yearItem.yearName, yearIndex)">
                  {{ yearItem.yearName }}
                </div>
              </div>
              <div class="">
                <!-- 年份 -->
                <div
                  class="type-item"
                  v-for="(yearItem, yearIndex) in videoList"
                  :key="`${yearItem.resourceType}-${yearItem.yearName}-${yearIndex}`">
                  <!-- 图片 -->
                  <div
                    class="type-item-box row-flex-wrap"
                    v-for="(itemImage, itemIndex) in yearItem.children"
                    v-show="`${yearItem.yearName}-${yearIndex}` == videoYearIndex"
                    :key="`${yearIndex}-${itemImage.id}`"
                    :data-Index="`${yearItem.yearName}-${yearIndex}`"
                    :data-activ="videoYearIndex">
                    <!-- 图片 picList -->
                    <div
                      class="image-box"
                      v-for="(item, picIndex) in itemImage.picList"
                      :key="`${yearIndex}-${itemImage.id}-${picIndex}`">
                      <video
                        :src="item"
                        preload="metadata"
                        width="258"
                        height="158"
                        class="video-box"
                        controls></video>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="item row-flex-wrap" v-for="item in videoList" :key="item.id">
                <div class="item-box" v-for="(itemImage, index) in item.picList" :key="index">
                  <video :src="itemImage" preload="metadata" width="258" height="158" class="video-box"
                    controls></video>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue'
  import { getXOssWebpSize } from '~/utils/common'

  const props = defineProps({
    detail: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    }
  })

  const firstIndex = ref(0)
  const activeIndex = ref(0)
  const imageList = ref<Array<any>>([])
  const videoList = ref<Array<any>>([])
  const imageTypeIndex = ref(0)
  const tabYearActive = ref('现场图片-0')
  const yearActiveIndex = ref('现场图片-0')
  const videoYearActive = ref('')
  const videoYearIndex = ref<string | number>(0)

  // 计算展馆图片列表
  const exhibitionHallList = computed(() => {
    const str = props.detail.pavilionInfo.picture
    let list = str.split(';')
    let newList: string[] = []
    if (Array.isArray(list)) {
      list.map((ImageItem: any) => {
        if (!ImageItem.includes('!swebp') && !ImageItem.includes('x-oss-process')) {
          // 如果不包含，则在URL末尾添加!swebp后缀
          // str = item.resourceUrl + getXOssWebpSize({ w: 800, h: 560, watermark: false })
          ImageItem = ImageItem + getXOssWebpSize({ w: 800, h: 560, watermark: false })
          newList.push(ImageItem)
        }
      })
    }

    return newList.length > 0 ? newList : []
  })

  // 监听 list 属性的变化
  watch(
    () => props.list,
    newList => {
      // console.log('展会视图-原始数据', newList, Array.isArray(newList));
      const filteredList = newList.filter((item: any) => item.resourceUrl)
      // console.log('图片不为空的数据', filteredList, filteredList.length > 0);
      if (filteredList.length > 0) {
        imageList.value = handleImage(filteredList)
        videoList.value = handleVideo(filteredList)
        //   console.log('161-',videoList)
        tabYearActive.value = `${imageList.value[0].name}-0`
        yearActiveIndex.value = `${imageList.value[0].name}-0`
      } else {
        imageTypeIndex.value = 99
      }
    },
    { immediate: true }
  )

  // 切换第一级标签
  const handleFirstTab = (i: number) => {
    firstIndex.value = i
    if (i === 1 && videoList.value.length > 0) {
      videoYearActive.value = `${videoList.value[0].yearName}-0`
      videoYearIndex.value = `${videoList.value[0].yearName}-0`
    }
  }

  // 切换图片类型标签
  const handleTabType = (name: string, i: number) => {
    imageTypeIndex.value = i
    tabYearActive.value = `${name}-0`
    yearActiveIndex.value = `${name}-0`
  }

  // 切换年份标签
  const handleTabYear = (a: string, b: number) => {
    if (firstIndex.value === 0) {
      yearActiveIndex.value = `${a}-${b}`
      tabYearActive.value = `${a}-${b}`
    } else if (firstIndex.value === 1) {
      videoYearIndex.value = `${a}-${b}`
    }
  }

  // 处理图片数据
  const handleImage = (list: any) => {
    let result: any = [
      { name: '现场图片', resourceType: 2, active: 0, children: [] },
      { name: '展位图', resourceType: 1, active: 0, children: [] }
    ]
    const imgList = list.filter((i: any) => i.resourceType !== 4)
    result.forEach((item: any) => {
      const year = getYearList(imgList, item.resourceType)
      item.children.push(...year)
    })
    result = result.filter((item: any) => item.children.length !== 0)
    return result
  }

  // 处理视频数据
  const handleVideo = (list: any) => {
    const imgList = list.filter((i: any) => i.resourceType === 4)
    return imgList.length > 0 ? getYearList2(imgList, 4) : []
  }

  // 获取年份的子级
  const getYearList = (list: any, resourceType: number) => {
    let result: any = []
    list.forEach((item: any) => {
      // item.picList = item.resourceUrl.split(',')
      let picListResource: string[] = []
      let imageListReource = item.resourceUrl.split(',')
      if (Array.isArray(imageListReource)) {
        imageListReource.map((ImageItem: any) => {
          if (!ImageItem.includes('!swebp') && !ImageItem.includes('x-oss-process')) {
            // 如果不包含，则在URL末尾添加!swebp后缀
            // str = item.resourceUrl + getXOssWebpSize({ w: 800, h: 560, watermark: false })
            let str = ImageItem + getXOssWebpSize({ w: 800, h: 560, watermark: false })

            picListResource.push(str)
          }
        })
      }

      item['picList'] = picListResource
      if (
        item.resourceType === resourceType &&
        !result.some((y: any) => y.yearName === item.resourceYear)
      ) {
        result.push({
          yearName: item.resourceYear,
          resourceYear: item.resourceYear,
          resourceType: item.resourceType,
          children: []
        })
      }
    })
    let sortList = result.sort((a: any, b: any) => b.resourceYear - a.resourceYear)

    if (Array.isArray(sortList) && sortList.length > 0 && sortList[0].resourceYear.includes('往届'))
      sortList.push(sortList.shift())
    sortList.forEach((item: any) => {
      const filterList = list.filter(
        (i: any) => i.resourceType === item.resourceType && i.resourceYear === item.yearName
      )
      item.children = filterList
    })
    return sortList
  }

  // 获取视频年份的子级
  const getYearList2 = (list: any, resourceType: number) => {
    let result: any = []
    list.forEach((item: any) => {
      item.picList = item.resourceUrl.split(',')
      if (
        item.resourceType === resourceType &&
        !result.some((y: any) => y.yearName === item.resourceYear)
      ) {
        result.push({
          yearName: item.resourceYear,
          resourceYear: item.resourceYear,
          resourceType: item.resourceType,
          children: []
        })
      }
    })
    let sortList = result.sort((a: any, b: any) => b.resourceYear - a.resourceYear)
    if (sortList[0].resourceYear.includes('往届')) sortList.push(sortList.shift())
    sortList.forEach((item: any) => {
      const filterList = list.filter(
        (i: any) => i.resourceType === item.resourceType && i.resourceYear === item.yearName
      )
      item.children = filterList
    })
    return sortList
  }
</script>

<style lang="less" scoped>
  .content-section {
    margin-top: 10px;
    padding-top: 0 !important;
    margin-bottom: 0 !important;

    .exhibition-view {
      .tab-head-first {
        height: 60px;
        border-bottom: 1px solid #e9e9e9;

        .name {
          height: 59px;
          line-height: 58px;
          margin: 0 28px;
          font-size: 16px;
          color: #666;
          // border-bottom:2px solid #e50113;
          &:hover {
            cursor: pointer;
          }

          &.active {
            font-size: 18px;
            color: #e50113;
            border-bottom: 3px solid #e50113;
          }
        }
      }

      .tab-content-first {
        min-height: 760px;
      }

      .tab-head {
        padding: 24px 0 26px 0;

        .name {
          padding-right: 16px;
          margin-right: 20px;
          color: #666;

          &.active {
            color: #e50113;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }

      .tab-content {
        .tab-year {
          font-size: 14px;
        }

        .year-box {
          padding: 20px 0;
          padding-top: 0;
          gap: 0 20px;

          .year-item {
            &.active {
              color: #e50113;
            }

            &:hover {
              cursor: pointer;
            }
          }
        }

        .type-item {
          align-items: center;

          .type-item-box {
            gap: 10px;
          }

          .image-box {
            width: 258px;
            height: 158px;
            // border:solid 1px #f0f0f0;
            border-radius: 6px;
            overflow: hidden;

            .item-image {
              max-width: 100%;
            }

            .video-box {
              object-fit: contain;
            }
          }
        }
      }
    }
  }
</style>
